import { useDispatch } from "react-redux";
import {
  setAccessToken,
  setProfileDetails,
  setWsCredentials,
} from "../store/modules/profile";
import { pathConstants } from "../routes/pathContants";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ToastContext } from "./context";

const useGrantAccessToApp = ({ message }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);

  const setAuthTokensAndGrantAccessToApp = ({
    refreshToken,
    accessToken,
    profileDetails,
    wsCredentials,
  }) => {
    localStorage.setItem("refreshToken", refreshToken);

    dispatch(setAccessToken(accessToken));
    dispatch(setProfileDetails(profileDetails));

    // Store WS credentials so useWebSocketManager can connect immediately
    // without an extra round-trip to /realtime/ws/token/
    if (wsCredentials?.token && wsCredentials?.socketUrl) {
      dispatch(setWsCredentials(wsCredentials));
    }

    triggerToast(message, "success");
    navigate(getDefaultRoute());
  };

  const getDefaultRoute = () => {
    if (localStorage.getItem("nextRoute")) {
      let pathname = localStorage.getItem("nextRoute");
      localStorage.removeItem("nextRoute");
      return pathname;
    }

    return pathConstants.DASHBOARD_MAIN;
  };

  return { setAuthTokensAndGrantAccessToApp };
};
export default useGrantAccessToApp;
